export default "/assets/mild-active-purple.svg";